<script lang="ts" setup>
withDefaults(
  defineProps<{
    title: string;
    textAlign?: "left" | "center" | "right";
  }>(),
  {
    textAlign: "left",
  }
);
</script>

<template>
  <h2
    class="font mb-4 text-xl leading-[120%] font-semibold md:text-[32px]"
    :class="{
      'text-left': textAlign === 'left',
      'text-center': textAlign === 'center',
      'text-right': textAlign === 'right',
    }"
  >
    {{ title }}
  </h2>
</template>
